import { React, useState, useEffect } from "react";

const PopUpHeadtailResults = ({ resultsData, catMid, marketType }) => {
    const resultData = resultsData;

    useEffect(() => {
        console.log("Market Type:", marketType);
        console.log("Results Data:", resultsData);
    }, [resultsData, marketType]);

    const dataObj = resultsData;


    const formatMarketStartTime = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return "";
        return date.toLocaleString("en-US", {
            month: "numeric",
            day: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "2-digit",
            second: "2-digit",
            hour12: true
        });
    };

    let headTailMarkets = [];
    let headTailWinner = "";

    if (marketType == 14) {

        headTailMarkets = [
            resultData.cat_rnr1,
            resultData.cat_rnr2,
        ].filter(Boolean);

        headTailWinner =
            (resultData.resultTxt || "")
                .replace("Heads", "Head")
                .replace("Tails", "Tail");
    }

    return (
        <div>
            <div id="ResultsData">
                <div class="left-content site_family">

                    <div id="head-tail" style={{ display: marketType == 14 ? "" : "none" }}>
                        <div className="left-content">
                            <div className="card">
                                <div className="card-header">
                                    Market Start Time = {formatMarketStartTime(dataObj.evt_od)}
                                </div>
                                <div className="card-body">
                                    <div className="player-item">
                                        <b>
                                            <span
                                                className="name"
                                                style={{ color: "#000" }}
                                            >
                                                Head & Tail
                                            </span>
                                        </b>
                                    </div>
                                    <div style={{ marginTop: "10px" }}>
                                        {headTailMarkets.map((market, index) => {
                                            const winner = market === headTailWinner;
                                            return (
                                                <div
                                                    key={index}
                                                    style={{
                                                        textAlign: "center",
                                                        marginBottom: "18px",
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            fontSize: "22px",
                                                            fontWeight: "700",
                                                        }}
                                                    >
                                                        {market}
                                                    </div>
                                                    <div
                                                        style={{
                                                            fontSize: "15px",
                                                            fontWeight: "600",
                                                            marginTop: "4px",
                                                            color: "#000",
                                                            textTransform: "uppercase",
                                                        }}
                                                    >
                                                        {winner ? "WINNER" : "LOSER"}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default PopUpHeadtailResults;

